<div class="row m-widget1" [formGroup]="group">
	<div class="col-xl-12">
		<div class="m-form__heading">
			<h4 class="m-form__heading-title">
				Preferences:
			</h4>
		</div>
		<div class="row padding-10">
			<div class="form-group m-form__group col-12">
				<div class="row">
					<label class="col-form-label col-lg-2 col-sm-12">
						<p>From Where did you</p>
						<p>hear about us:</p>
					</label>
					<div class="col-lg-10 col-md-10 col-sm-12">
						<select class="form-control" formControlName="heardFrom">
							<option value="" disabled selected>Select Source</option>
							<option value="Internet">Internet</option>
							<option value="Friends">Friends</option>
							<option value="Newsletter">Newsletter</option>
							<option value="Others">Others</option>
						</select>
						<!-- <app-form-control-messages [control]="group.get('preferences').controls('heardAboutUs')"
                                                [name]="'Sector'"></app-form-control-messages> -->
					</div>
				</div>
			</div>
		</div>
		<div class="bottom-border"></div>

		<!-- <div formArrayName="tempEducationDetails" class="m-form__section m-form__section--first m-widget1__item" *ngFor="let education of group.get('educationAndWorkDetails').get('education')['controls']; let i=index"> -->
		<div formGroupName="preferences">
			<div formArrayName="coursePreferences" *ngFor="let coursePreferences of group.get('preferences').get('coursePreferences')['controls']; let i=index"
			    style="padding-top:10px">
				<div [formGroupName]="i">


					<div class="row padding-10">
						<div class="form-group m-form__group col-6">
							<div class="row">
								<label class=" col-lg-4 col-sm-12 col-form-label">
									Select Sector:
									<span class="red">*</span>
								</label>
								<div class="col-lg-8 col-md-8 col-sm-12">
									<select class="form-control" [compareWith]="showSelected" (change)="getSubSectors(coursePreferences.get('sectorObj').value,i,false)"
									    formControlName="sectorObj">
										<option value="" disabled selected>Select Sector</option>
										<option *ngFor="let sector of sectors" [ngValue]="sector">{{sector.sector}}</option>
									</select>
									<app-form-control-messages [control]="group.get('preferences').get('coursePreferences').controls[i].get('sectorObj')" [name]="'Sector'"></app-form-control-messages>
								</div>
							</div>
						</div>
						<div class="form-group m-form__group col-6 padding-0">
							<div class="row">
								<label class="col-xl-4 col-lg-4 col-form-label">
									Select Sub-Sector:
									<span class="red">*</span>
								</label>
								<div class="col-xl-8 col-lg-8">
									<select class="form-control" [compareWith]="showSelectedd" *ngIf="subSectors[i]" (change)="getJobRoles(coursePreferences.get('sectorObj').value,coursePreferences.get('subSectorObj').value,i,false)"
									    formControlName="subSectorObj">
										<option value="" disabled selected>Select Sub-Sector</option>
										<option *ngFor="let subSector of subSectors[i].subSectors" [ngValue]="subSector">{{subSector.subSectorName}}</option>
									</select>
									<app-form-control-messages [control]="group.get('preferences').get('coursePreferences').controls[i].get('subSectorObj')"
									    [name]="'Sub-Sector'"></app-form-control-messages>
								</div>
							</div>
						</div>
					</div>
					<div class="row padding-10">
						<div class="form-group m-form__group col-6">
							<div class="row">
								<label class="col-form-label col-lg-4 col-sm-12">
									Select Job Role:
									<span class="red">*</span>
								</label>
								<div class="col-lg-8 col-md-8 col-sm-12">
									<select class="form-control" *ngIf="jobRoles[i]" (change)="getQpCode(
										group.get('preferences').get('coursePreferences').controls[i].get('jobRole').value,i)"formControlName="jobRole">
										<option value="" disabled selected>Select Job Role</option>
										<option *ngFor="let jobRole of jobRoles[i].jobRoles" [ngValue]="jobRole.jobRole">{{jobRole.jobRole}}</option>
									</select>
									<app-form-control-messages [control]="group.get('preferences').get('coursePreferences').controls[i].get('jobRole')" [name]="'Job Role'"></app-form-control-messages>
								</div>
							</div>
						</div>
						<div class="form-group m-form__group col-6 pull-right">
								<div class="pull-right margin-left-10">
								<button class="btn btn-secondary blue-outline-btn pull-right" type="button" (click)="addCoursePreference(i+1)" *ngIf="$last||group.get('preferences').get('coursePreferences').controls.length == i+1">Add Another Preference</button>
							</div>
							<div class="pull-right">
								<button class="btn btn-secondary blue-outline-btn pull-right" type="button" (click)="deleteCoursePreference(i)" *ngIf="group.get('preferences').get('coursePreferences').controls.length > 1">Remove</button>&nbsp; &nbsp;
							</div>


						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<!-- </div> -->
